import { render, staticRenderFns } from "./NPC.vue?vue&type=template&id=f21aa4ea&scoped=true&"
import script from "./NPC.vue?vue&type=script&lang=js&"
export * from "./NPC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21aa4ea",
  null
  
)

export default component.exports